import React, { useState } from "react";
import { Container, Row, Col, Form, Button, Card } from "react-bootstrap";
import { handleVerifyOTP } from "../../store/actions/userActions";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import logo from "../../assets/icons/logo.svg";
import { IMAGES } from "../../constants/constants";
import "../../styles/Dashboard.css";
import "./login.css";

function VerifyOTP() {
  const { email } = useParams(); // Get email from URL parameters
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [formData, setFormData] = useState({
    email: email || "",
    otp: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const result = await handleVerifyOTP(formData, dispatch);

    if (result.message === "Success") {
      //navigate("/update-password");
      navigate(`/update-password/${formData.email}`);
    } else {
      console.error("OTP verification failed");
    }
  };

  return (
    <Container
      fluid
      className="d-flex align-items-center justify-content-center"
      style={{ minHeight: "100vh", backgroundColor: "#f8f9fa" }}
    >
      <Card className="auth-card">
        <Row className="g-0">
          {/* Left Section - OTP Form */}
          <Col md={6}>
            <Card.Body className="d-flex flex-column auth-form-body">
              <div className="mb-4 auth-form-logo">
                <img src={logo} alt="logo" />
              </div>
              <p>Verify OTP</p>
              <p>Enter the OTP sent to your email.</p>
              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3" controlId="formOTP">
                  <Form.Label className="auth-form-label">
                    OTP<span>*</span>
                  </Form.Label>
                  <Form.Control
                    className="auth-form-input"
                    type="text"
                    placeholder="Enter OTP"
                    name="otp"
                    value={formData.otp}
                    onChange={handleChange}
                  />
                </Form.Group>

                <Button
                  type="submit"
                  className="w-100 auth-form-btn"
                  style={{ backgroundColor: "#56934e", border: "#56934e" }}
                >
                  Verify OTP
                </Button>
              </Form>
            </Card.Body>
          </Col>

          {/* Right Section - Static Image */}
          <Col
            md={6}
            className="d-flex justify-content-center align-items-center"
          >
            <div
              className="h-100 w-100"
              style={{
                backgroundImage: `url(${IMAGES.loginFormImage})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                borderRadius: "0 15px 15px 0",
              }}
            ></div>
          </Col>
        </Row>
      </Card>
    </Container>
  );
}

export default VerifyOTP;
